//#region src/consts.ts
const unknownString = "unknown";
//#endregion
export { unknownString };

//# sourceMappingURL=consts.js.map